module.exports = __webpack_public_path__ + "img/img20.a3e5bbf2.png";